var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../../utils/common-utils.js');

var PersonsCollection = require('../../../collections/persons-collection');

var YesNoConfirmationModal = require('../../common/yes-no-confirmation-modal');
var MarkAsSignedForm = require('../mark-as-signed-form');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var utils = new CommonUtils();


var HistoryRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../../templates/documents/history/document-history-row.html'),

    ui: {
        commentContainer: '.comment-container',
        textarea: '.textarea',
        spans: '.spans',
        add: '.add',
        edit: '.edit',
        save: '.save',
        cancel: '.cancel',
        markAsDelivered: '.mark-as-delivered',
        markAsSigned: '.mark-as-signed',

        showCommentChangeHistory: ".show-comment-history"
    },

    events: {
        'click @ui.spans': 'onAddOrEdit',
        'click @ui.save': 'onSave',
        'click @ui.cancel': 'onCancel',
        'click @ui.markAsDelivered': 'onMarkAsDelivered',
        'click @ui.markAsSigned': 'onMarkAsSigned',
        'click @ui.showCommentChangeHistory': 'onShowCommentChangeHistory'
    },

    templateContext: function () {
        var that = this;
        return {
            time: utils.longToDateTimeFormatted(Number(that.model.get('time')), 'MM/DD/YYYY hh:mm A'),
            canEdit: that.getOption('canEdit'),
            byAdmin: that.getOption('byAdmin'),
            isSentEvent: that.model.get('eventType') == 'SENT',
            isUnderReview: that.model.get('eventType') == 'UNDER_REVIEW' && that.getOption('status') == 'UNDER_REVIEW',
            isNotCommentEvent: that.model.get('eventType') != "COMMENT_ADDED" && that.model.get('eventType') != "COMMENT_BECAME_IRRELEVANT"
        }
    },

    initialize: function (options) {
    },

    onRender: function () {
        var that = this;
        that.ui.textarea.hide();
        that.ui.save.hide();
        that.ui.cancel.hide();
        that.commentHistoryContent = null;
    },

    onAddOrEdit: function () {
        this.ui.commentContainer.hide();
        this.ui.spans.hide();
        this.ui.textarea.show();
        this.ui.save.show();
        this.ui.cancel.show();
    },

    onSave: function () {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/event/' + that.model.get('id') + '/comment',
            data: this.ui.textarea.val(),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    if (response) {
                        utils.hideSpinner();
                        that.model.set('auditComment', response.auditComment);
                        that.model.set('commentHistory', response.commentHistory);
                        that.render();
                    }
                }
            },
            error: function (e) {
                utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    },

    onCancel: function () {
        this.ui.textarea.val(this.model.get('auditComment') || '');

        this.ui.commentContainer.show();
        this.ui.spans.show();
        this.ui.textarea.hide();
        this.ui.save.hide();
        this.ui.cancel.hide();
    },

    onMarkAsDelivered: function () {
        var that = this;
        var parentId = this.model.get('parentId');
        if (_.isEmpty(parentId))
            return;

        var newDeliveredEvent = {
            parentId: parentId,
            eventType: 'DELIVERED',
            auditComment: 'Marked as delivered from UI'
        };

        that.triggerMethod('mark-as-delivered', {
            event: newDeliveredEvent
        });
    },

    onMarkAsSigned: function () {
        var that = this;
        var parentId = this.model.get('parentId');
        var parentVersion = this.model.get('parentVersion');

        if (parentId && parentVersion) {
            that.triggerMethod('mark-as-signed', {
                parentId: parentId,
                parentVersion: parentVersion
            });
        }
    },

    onShowCommentChangeHistory: function (e) {
        var self = $(e.target);
        var that = this;

        if (!that.commentHistoryContent) {
            self.popover({
                html: true,
                content: "<b>Loading...</b>"
            });
            self.popover('show');

            var popoverAsyncRender = function (commentHistoryContent) {
                that.commentHistoryContent = commentHistoryContent;
                self.attr("data-content", that.commentHistoryContent);
                self.popover({
                    html: true
                });
                self.popover('show');
            }

            that.renderHistory(popoverAsyncRender);

        } else {
            self.attr("data-content", that.commentHistoryContent);
            self.popover({
                html: true
            });
            self.popover('show');
        }
    },

    renderHistory: function (popoverRender) {
        var that = this;
        var commentHistory = that.model.get("commentHistory");
        var authors = commentHistory.map(function (ch) {
            return {key: 'id', value: ch.authorId};
        });

        var personsCollection = new PersonsCollection([], {
            params: _.union([
                {key: 'active', value: 'true'},
                {key: 'active', value: 'false'}
            ], authors)
        });

        personsCollection.fetch({
            success: function () {
                var authorsWithNames = {};
                personsCollection.forEach(function (model) {
                    authorsWithNames[model.get("id")] = model.get("name");
                })

                var tableStart = '<table class="table table-hover top-margined">' +
                    '<thead><tr><th>Time</th><th>Commenter</th><th>Old Comment</th><th>New Comment</th></tr></thead><tbody>';
                var tableEnd = '</tbody></table>';
                var tableContent = _.chain(commentHistory)
                    .sortBy("time")
                    .reverse()
                    .map(function (ch) {
                        return '<tr><td>' + utils.longToDateTimeFormatted(ch.time, 'MM/DD/YYYY hh:mm A')
                            + '</td><td>' + '<a href = "/#person/' + ch.authorId + '" target="_blank">' + authorsWithNames[ch.authorId] + '</a>'
                            + '</td><td>' + (ch.oldComment || '')
                            + '</td><td>' + (ch.newComment || '')
                            + '</td></tr>';
                    })
                    .value();
                popoverRender(tableStart + tableContent + tableEnd);
            },
            error: function (e) {
                console.log(e);
                popoverRender("Error - " + e.toString());
            }
        });
    },

    hideCommentsHistory: function () {
        var that = this;
        that.ui.showCommentChangeHistory.each(function () {
            var self = $(this);
            //if (that.activeCommentChangeHistoryPopoverId != self.attr("id")) {
            //self.popover("hide");
            self.popover("destroy");
            //}
        });
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var HistoryTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: HistoryRowView,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'mark-as-delivered': 'markAsDelivered',
        'mark-as-signed': 'markAsSigned'
    },

    childViewOptions: function () {
        var that = this;
        return {
            canEdit: that.getOption('canEdit'),
            byAdmin: that.getOption('byAdmin'),
            status: that.getOption('status')
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
        this.collection = options.collection;
    },


    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        notificationsChannel.request('show:notification', response.responseText);
    },

    markAsDelivered: function (data) {
        this.triggerMethod('mark-as-delivered', data);
    },

    markAsSigned: function (data) {
        this.triggerMethod('mark-as-signed', data);
    },

    hideCommentsHistory: function () {
        this.children.each(function (view) {
            view.hideCommentsHistory();
        })
    }

});

var DocumentHistoryView = Marionette.View.extend({
    tagName: 'div',
    className: 'history-table',
    template: require('../../../templates/documents/history/document-history-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        markedAsDeliveredConfirmationModal: '#marked-as-delivered-confirmation-modal',
        markAsSignedModal: '#mark-as-signed-modal'
    },

    childViewEvents: {
        'mark-as-delivered': 'markAsDelivered',
        'mark-as-signed': 'markAsSigned',
        'action:confirmed': 'onConfirmed',
        'document:marked:as:signed': 'onDocumentMarkedAsSigned'
    },

    templateContext: function () {
        return {
            documentName: this.getOption('name'),
            documentId: this.getOption('id'),
            baseParentIdPath: this.getOption('baseParentIdPath'),
            parentUrl: this.getOption('baseParentIdPath') + this.getOption('id')
        }
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(that, 'onRender', 'renderTable');
        this.canEdit = options.canEdit;
        this.byAdmin = options.byAdmin;
        this.document = options.document || {};
    },

    onRender: function () {
        var that = this;
        that.getDataAndRender();

        that.markedAsDeliveredConfirmationModal =
            new YesNoConfirmationModal({message: 'Are you sure you want to mark this message as delivered?'});
        that.showChildView('markedAsDeliveredConfirmationModal', that.markedAsDeliveredConfirmationModal);

        window.setTimeout(function () {
            $(function () {
                $("body").click(function (event) {
                    var clicked = $(event.target);
                    var popover = clicked.closest(".popover");

                    if (clicked.hasClass('popover-content') || clicked.hasClass("show-comment-history") || popover.html())
                        return;

                    that.getChildView("body").hideCommentsHistory();
                });
            });
        }, 1000);
    },

    onBeforeDestroy: function () {
        $("body").unbind("click");
    },

    getDataAndRender: function () {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "GET",
            url: '/api/event/all/' + that.getOption('id'),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.collection = new Backbone.Collection(response);
                    that.renderTable();
                }
            },
            error: function (e) {
                utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    renderTable: function () {
        this.showChildView('body', new HistoryTableBody({
            collection: this.collection,
            canEdit: this.canEdit,
            byAdmin: this.byAdmin,
            status: this.document.status
        }));

        this.asyncHandleComments();
    },

    asyncHandleComments: function () {

        console.log('asyncHandleComments');

        /*$.ajax({
            type: "GET",
            url: '/api/event/all/' + that.getOption('id'),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.collection = new Backbone.Collection(response);
                    that.renderTable();
                }
            },
            error: function (e) {
                utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });*/
    },

    markAsDelivered: function (data) {
        var that = this;
        that.markedAsDeliveredConfirmationModal.show();

        that.callback = function () {

            utils.showSpinner();
            $.ajax({
                type: "POST",
                url: '/api/event',
                data: JSON.stringify(data.event),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        utils.hideSpinner();
                        that.getDataAndRender();
                    }
                },
                error: function (e) {
                    utils.hideSpinner();
                    if (e.status == 401) {
                        actionsChannel.request("redirect:to:login");
                    } else {
                        notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                    }
                }
            });
        };
    },

    markAsSigned: function (data) {
        var that = this;
        that.showChildView('markAsSignedModal', new MarkAsSignedForm({
            documentId: data.parentId,
            documentVersion: data.parentVersion
        }));
    },

    onConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.markedAsDeliveredConfirmationModal.hide();
        }
    },

    onDocumentMarkedAsSigned: function () {
        window.setTimeout(function () {
            window.location.reload();
        }, 2000);
    }
});

module.exports = DocumentHistoryView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/history/document-history-view.js
// module id = 416
// module chunks = 0